module.exports = __webpack_public_path__ + "static/img/app.9420a77.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/index/app.png
// module id = 1170
// module chunks = 18